// store/mainChat/mutations.js

// ============ UNIFIED CONVERSATIONS MUTATIONS ============

export const setConversationPayload = (state, payload) => {
    state.conversations.payload = payload;
    state.conversationPayload = payload;
};

export const setConversationsLoading = (state, isLoading) => {
    state.conversations.isLoading = isLoading;
};

export const resetConversations = (state, list) => {
    state.conversations.data = list || [];
    state.conversations.lastFetched = new Date().toISOString();
    state.conversations.isLoading = false;
};

export const mutateConversations = (state, updates) => {
    if (!Array.isArray(updates)) {
        updates = [updates];
    }

    let needsSort = false;

    updates.forEach((update) => {
        const { op, data } = update;
        if (!data) return;

        const id = String(data._id || data.id);
        if (!id) return;

        const index = state.conversations.data.findIndex(
            (c) => String(c._id || c.id) === id
        );

        switch (op) {
            case "added":

                if (index === -1) {
                    state.conversations.data.unshift(normalizeConversation(data));
                } else {
                    const existing = state.conversations.data[index];
                    state.conversations.data[index] = {
                        ...existing,
                        ...normalizeConversation(data, existing),
                    };
                }
                needsSort = true;
                break;

            case "modified":

                if (index !== -1) {
                    const existing = state.conversations.data[index];
                    state.conversations.data[index] = {
                        ...existing,
                        ...normalizeConversation(data, existing),
                        chatType: existing.chatType,
                    };
                    if (data.lastMessage !== undefined) {
                        needsSort = true;
                    }
                }
                break;

            case "removed":
                if (index !== -1) {
                    state.conversations.data.splice(index, 1);
                }
                break;

            default:
                console.warn("[mutateConversations] Unknown operation:", op);
        }
    });

    // Sort by lastMessage nếu cần
    if (needsSort) {
        state.conversations.data.sort((a, b) => {
            const timeA = a.lastMessage ? new Date(a.lastMessage).getTime() : 0;
            const timeB = b.lastMessage ? new Date(b.lastMessage).getTime() : 0;
            return timeB - timeA;
        });
    }

    state.conversations.data = [...state.conversations.data];
};

export const clearConversations = (state) => {
    state.conversations.data = [];
    state.conversations.payload = null;
    state.conversations.isLoading = false;
};

function normalizeConversation(doc, existing = null) {
    const id = doc._id || doc.id;

    let chatType;
    if (existing?.chatType) {
        chatType = existing.chatType;
    } else if (doc.chatType) {
        chatType = doc.chatType;
    } else {
        chatType = doc.AssigneeUserId?.length > 2 ? 'groupChat' : 'oneToOne';
    }

    const normalized = {
        ...(existing || {}),
        ...doc,
        id,
        _id: id,
        chatType,
        isGroupChat: chatType === 'groupChat',
        isGroup: chatType === 'groupChat',
    };

    if (doc.UserAdmin !== undefined) {
        normalized.UserAdmin = doc.UserAdmin;
    }
    if (doc.memberPermissions !== undefined) {
        normalized.memberPermissions = doc.memberPermissions;
    }
    if (doc.AssigneeUserId !== undefined) {
        normalized.AssigneeUserId = doc.AssigneeUserId;
    }

    // Name
    if (doc.name !== undefined) {
        normalized.name = doc.name;
        normalized.TaskName = doc.name;
    } else if (doc.GroupName !== undefined) {
        normalized.name = doc.GroupName;
        normalized.TaskName = doc.GroupName;
    }

    // lastMessage
    if (doc.lastMessage !== undefined) {
        normalized.lastMessage = doc.lastMessage;
    } else if (doc.lastMessageTime !== undefined) {
        normalized.lastMessage = doc.lastMessageTime;
    } else if (doc.lastMessageObj?.createdAt !== undefined) {
        normalized.lastMessage = doc.lastMessageObj.createdAt;
    }

    // message preview
    if (doc.message !== undefined) {
        normalized.message = doc.message;
    }
    
    return normalized;
}

// function detectChatType(doc, existing = null) {
//     if (doc.chatType) return doc.chatType;
//     if (doc.isGroupChat === true || doc.isGroup === true) return 'groupChat';
//     if (doc.isGroupChat === false || doc.isGroup === false) return 'oneToOne';
//     if (existing?.chatType) return existing.chatType;

//     const members = doc.AssigneeUserId || doc.members || [];
//     return members.length > 2 ? 'groupChat' : 'oneToOne';
// }

// ============ LEGACY CHATS MUTATIONS ============

export const setChatPayload = (state, payload) => {
    state.chatPaylaod = payload;
};

export const resetChats = (state, list) => {
    state.chats.data = list || [];
};

export const mutateChats = (state, updates) => {
    if (!Array.isArray(updates)) {
        updates = [updates];
    }

    updates.forEach(update => {
        const { op, data } = update;
        if (!data) return;

        const id = String(data._id || data.id);
        const index = state.chats.data.findIndex(
            (c) => String(c._id || c.id) === id
        );

        switch (op) {
            case "added":
                if (index === -1) state.chats.data.push(data);
                break;
            case "modified":
                if (index !== -1) state.chats.data[index] = { ...state.chats.data[index], ...data };
                break;
            case "removed":
                if (index !== -1) state.chats.data.splice(index, 1);
                break;
        }
    });

    state.chats.data = [...state.chats.data];
};

// ============ LEGACY GROUP CHATS MUTATIONS ============

export const setGroupChatPayload = (state, payload) => {
    state.groupChatPayload = payload;
};

export const resetGroupChats = (state, list) => {
    state.groupChats.data = list || [];
};

export const mutateGroupChats = (state, updates) => {
    if (!Array.isArray(updates)) {
        updates = [updates];
    }

    updates.forEach(update => {
        const { op, data } = update;
        if (!data) return;

        const id = String(data._id || data.id);
        const index = state.groupChats.data.findIndex(
            (gc) => String(gc._id || gc.id) === id
        );

        switch (op) {
            case "added":
                if (index === -1) state.groupChats.data.push({ ...data, isGroupChat: true });
                break;
            case "modified":
                if (index !== -1) {
                    state.groupChats.data[index] = { ...state.groupChats.data[index], ...data, isGroupChat: true };
                }
                break;
            case "removed":
                if (index !== -1) state.groupChats.data.splice(index, 1);
                break;
        }
    });

    state.groupChats.data = [...state.groupChats.data];
};

// ============ PROJECTS MUTATIONS ============

export const mutateChatProjects = (state, updates) => {
    if (!Array.isArray(updates)) {
        updates = [updates];
    }

    updates.forEach(update => {
        const { op, data } = update;
        if (!data) return;

        const id = String(data._id || data.id);
        const index = state.mainChatProjects.data.findIndex(
            (p) => String(p._id || p.id) === id
        );

        switch (op) {
            case "added":
                if (index === -1) state.mainChatProjects.data.push(data);
                break;
            case "modified":
                if (index !== -1) {
                    state.mainChatProjects.data[index] = { ...state.mainChatProjects.data[index], ...data };
                }
                break;
            case "removed":
                if (index !== -1) state.mainChatProjects.data.splice(index, 1);
                break;
        }
    });
};

// ============ SPRINTS MUTATIONS ============

export const mutateChatSprints = (state, update) => {
    const { op, data } = update;
    if (!data) return;

    const projectId = data.projectId;
    if (!projectId) return;

    if (!state.mainChatSprints.data[projectId]) {
        state.mainChatSprints.data[projectId] = [];
    }

    const sprintId = String(data._id || data.id);
    const index = state.mainChatSprints.data[projectId].findIndex(
        (s) => String(s._id || s.id) === sprintId
    );

    switch (op) {
        case "added":
            if (index === -1) state.mainChatSprints.data[projectId].push(data);
            break;
        case "modified":
            if (index !== -1) {
                state.mainChatSprints.data[projectId][index] = {
                    ...state.mainChatSprints.data[projectId][index],
                    ...data,
                };
            }
            break;
        case "removed":
            if (index !== -1) state.mainChatSprints.data[projectId].splice(index, 1);
            break;
    }
};

// ============ FOLDERS MUTATIONS ============

export const mutateChatFolders = (state, update) => {
    const { op, data } = update;
    if (!data) return;

    const projectId = data.projectId;
    if (!projectId) return;

    if (!state.mainChatFolders.data[projectId]) {
        state.mainChatFolders.data[projectId] = [];
    }

    const folderId = String(data._id || data.id);
    const index = state.mainChatFolders.data[projectId].findIndex(
        (f) => String(f._id || f.id) === folderId
    );

    switch (op) {
        case "added":
            if (index === -1) state.mainChatFolders.data[projectId].push(data);
            break;
        case "modified":
            if (index !== -1) {
                state.mainChatFolders.data[projectId][index] = {
                    ...state.mainChatFolders.data[projectId][index],
                    ...data,
                };
            }
            break;
        case "removed":
            if (index !== -1) state.mainChatFolders.data[projectId].splice(index, 1);
            break;
    }
};

// ============ ROOM DATA MUTATIONS ============

export const setCommentRoomData = (state, data) => {
    state.commentRoomData = data;
};

export const setConversationRoomData = (state, data) => {
    state.conversationRoomData = data;
};

export const setConversationRoomName = (state, roomName) => {
    state.conversationRoomData = {
        ...state.conversationRoomData,
        roomName
    };
};
